import { isEmpty } from "../../../utils";

export const isLevelValidated = (level) => {
  let err = "";
  let isJsonCorrect = true;
  let currLevel = "";
  if (typeof level != "object") {
    try {
      if (level.length > 0) {
        currLevel = JSON.parse(level);
      }
    } catch (err) {
      isJsonCorrect = false;
    }
  } else {
    currLevel = level;
    currLevel.forEach((level) => {
      ["actions", "activation", "priority"].forEach((field) => {
        if (typeof level[field] != "object") {
          try {
            level[field] = JSON.parse(level[field]);
          } catch (error) {
            isJsonCorrect = false;
          }
        } else {
          try {
            var num = parseInt(level[field]);
          } catch (error) {
            isJsonCorrect = false;
          }
        }
      });
    });
  }

  if (!isJsonCorrect) {
    return "Level should be an object";
  }
  if (err == "") {
    currLevel.forEach((level) => {
      ["actions", "activation"].forEach((field) => {
        if (level[field] == undefined || !level[field]) {
          err += " " + field + " is Required";
        }
      });
    });
  }
  return err ? err : "validated";
};

export const clean = (object) => {
  Object.entries(object).forEach(([k, v]) => {
    if (v && typeof v === "object") {
      clean(v);
    }
    if (
      (v && typeof v === "object" && !Object.keys(v).length) ||
      v === null ||
      v === undefined
    ) {
      if (Array.isArray(object)) {
        object.splice(k, 1);
      } else {
        delete object[k];
      }
    }
  });
  return object;
};

export const isValidated = (initialState, mandatoryFields) => {
  let err = "";
  Object.keys(initialState).some((key) => {
    if (mandatoryFields.includes(key)) {
      if (
        initialState[key] === undefined ||
        initialState[key] === null ||
        initialState[key] === "" ||
        (Array.isArray(initialState[key]) && initialState[key].length === 0) ||
        (initialState[key] &&
          initialState[key] instanceof Object &&
          isEmpty(initialState[key]))
      ) {
        err = `${key} field is mandatory`;
        return err;
      }
    }
  });
  return err ? err : "validated";
};

export default { isLevelValidated, clean, isValidated };
